/* Move each product's registered facts into its purchase-support card. */
(() => {
  'use strict';
  function kind(text) {
    const s=text.normalize('NFKC').replace(/[\sー―—–−#：:]/g,'').toLowerCase();
    if(s==='description'||s==='商品説明'||s==='style')return 'description';
    if(s==='gleamline')return 'gleam-line';
    if(s==='artifactline')return 'artifact-line';
    if(s==='model'||s==='モデル')return 'model';
    if(s==='material'||s==='素材')return 'material';
    if(s==='seasonalfeeling')return 'season';
    if(['発送予定日','発送目安','お届け予定日','発送日数','発送について'].includes(s))return 'shipping';
    if(/^style\d+$/.test(s))return 'style';
    return null;
  }
  function plain(fragment){
    const box=document.createElement('div');box.append(fragment);
    box.querySelectorAll('br').forEach(b=>b.replaceWith('\n'));
    box.querySelectorAll('p,div,li').forEach(e=>e.append('\n'));
    return box.textContent.replace(/\u00a0/g,' ').split('\n').map(x=>x.trim()).filter(Boolean).join('\n');
  }
  function boundaries(desc){
    const result=[],walker=document.createTreeWalker(desc,NodeFilter.SHOW_TEXT);
    const decorated=text=>/^[ー―—–−-]\s*[^ー―—–−]+?\s*[ー―—–−-]$/.test(text.trim());
    const candidates=[...desc.querySelectorAll('strong,b,h2,h3,h4,h5,h6,span')].filter(el=>kind(el.textContent)||decorated(el.textContent));
    const containers=new Set(candidates.filter(el=>!candidates.some(other=>other!==el&&other.contains(el))));
    const seen=new Set();
    let node;
    while((node=walker.nextNode())){
      const text=node.textContent.trim();if(!text)continue;
      let container=node.parentElement;
      while(container!==desc&&!containers.has(container))container=container.parentElement;
      if(containers.has(container)){
        if(!seen.has(container)){result.push({node:container,kind:kind(container.textContent)});seen.add(container);}continue;
      }
      if(!text.replace(/[ー―—–−-]/g,'').trim())continue;
      const type=kind(text),parent=node.parentElement;
      const bold=parent.closest('strong,b,h2,h3,h4,h5,h6');
      // Older descriptions use plain text headings, spans, or several headings in one bold element.
      const inlineModel=/^[・•]?\s*モデル身長\s*[：:]?\s*\d+(?:\.\d+)?\s*cm\s*$/i.test(text.normalize('NFKC'));
      if(type||decorated(text)||(inlineModel&&result[result.length-1]?.kind!=='model')||(bold&&bold.textContent.trim()===text))result.push({node,kind:type});
    }
    return result;
  }
  function init(){document.querySelectorAll('[data-londa-pdp]').forEach(pdp=>{
    const card=pdp.querySelector('.londa-buy-help--product[data-londa-purchase-support]'),desc=pdp.querySelector('.lpd-description');
    if(!card||!desc||card.dataset.parsed)return;
    card.dataset.parsed='1';
    const headings=boundaries(desc);
    const facts={};const remove=[];
    for(let i=0;i<headings.length;i++){
      const h=headings[i];if(!h.kind)continue;
      // Remove only the generic description heading; retain all product-specific copy and links.
      if(h.kind==='description'){const range=document.createRange();range.selectNode(h.node);remove.push(range);continue;}
      const content=document.createRange();content.setStartAfter(h.node);
      if(headings[i+1])content.setEndBefore(headings[i+1].node);else content.setEnd(desc,desc.childNodes.length);
      const text=plain(content.cloneContents());
      if(text)facts[h.kind]=[facts[h.kind],text].filter(Boolean).join('\n');
      const range=content.cloneRange();range.setStartBefore(h.node);
      const replaced=h.kind==='style'?card.querySelector('[data-londa-style-links]'):
        ['gleam-line','artifact-line'].includes(h.kind)?card.querySelector('[data-londa-group="'+h.kind+'"]'):true;
      if(replaced)remove.push(range);
    }
    if(!facts.model){
      const walker=document.createTreeWalker(desc,NodeFilter.SHOW_TEXT);let node;
      while((node=walker.nextNode())){
        const text=node.textContent.trim();
        if(/^[・•]?\s*モデル身長\s*[：:]?\s*\d+(?:\.\d+)?\s*cm\s*$/i.test(text.normalize('NFKC'))){
          facts.model=text.replace(/^[・•]\s*/,'');
          const range=document.createRange();range.selectNodeContents(node);remove.push(range);break;
        }
      }
    }
    // Missing data is left blank; another product's measurements are never substituted.
    const modelInfo=(facts.model||'').normalize('NFKC').replace(/^[・•]\s*/gm,'').replace(/(?:モデル)?身長\s*[：:]/g,'モデル身長：').replace(/((?:着用)?サイズ)\s*[：:]/g,'$1：').replace(/\s*[/／]\s*(?=(?:着用)?サイズ\s*[：:])/g,'　').replace(/\n(?=(?:着用)?サイズ)/g,'　').trim();
    pdp.dataset.londaModelInfo=/^モデル身長：(?:なし|未記載|不明)$/.test(modelInfo)?'':modelInfo;
    pdp.dispatchEvent(new CustomEvent('londa:product-facts'));
    if(facts.material){card.querySelector('[data-support-material-value]').textContent=facts.material.replace(/\n/g,' ／ ');card.querySelector('[data-support-material]').hidden=false;}
    // The merchant's common delivery estimate is rendered by Liquid. Legacy product text
    // must never replace it with a missing-data message or a different delivery period.
    remove.reverse().forEach(range=>range.deleteContents());
    // Trim empty paragraphs created by moving metadata without removing product photos or unknown sections.
    [...desc.querySelectorAll('p,div,span')].reverse().forEach(el=>{if(!el.textContent.trim()&&!el.querySelector('img,video,iframe,table,a'))el.remove();});
    // Heading removal can leave leading line breaks inside old rich-text containers.
    [desc,...desc.querySelectorAll('p,div')].forEach(el=>{let node=el.firstChild;while(node&&(node.nodeType===3&&!node.textContent.trim()||node.nodeName==='BR')){const next=node.nextSibling;node.remove();node=next;}});
    desc.hidden=!desc.textContent.trim()&&!desc.querySelector('img,video,iframe,table');
  });}
  init();document.addEventListener('shopify:section:load',init);
})();
